module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4YuB0"))).then(() => parcelRequire('d0iPb'));